import type { SelectOption } from '@/shared/ui/selectTypes';

export const BID_STATUS = {
  NEW: 0,
  IN_WORK: 2,
  CANCELLED: 4,
  DONE: 5,
  PREMODERATION: -1,
} as const;

export const BID_STATUS_LABEL: Record<number, string> = {
  [-1]: 'Премодерация',
  0: 'Новая',
  1: 'Визит в сервис',
  2: 'В работе',
  3: 'Ремонт окончен',
  4: 'Отказ',
  5: 'Закрыта',
};

export const BID_CREATED_TYPE_FROM: Record<number, string> = {
  0: 'Заявка',
  1: 'Звонок',
};

export const FINE_STATUS: Record<number, string> = {
  0: 'Новый штраф',
  1: 'Запрошен возврат',
  2: 'Штраф возвращён',
  3: 'Отказ в возврате',
};

export const FINE_STATUS_OPTIONS: SelectOption[] = Object.entries(FINE_STATUS).map(([value, label]) => ({
  value,
  label,
}));

/** Legacy `BID_ADMIN_REJECT_REASONS`: reasons an operator picks when cancelling a bid. */
export const BID_ADMIN_REJECT_REASONS: SelectOption[] = [
  { value: '21', label: 'Нашёл дешевле / не устроила цена' },
  { value: '22', label: 'Не устроило время / нет свободных окон' },
  { value: '23', label: 'СТО проигнорировало заявку / сервис не вышел на связь' },
  { value: '24', label: 'Клиент не вышел на связь / недозвон' },
  { value: '25', label: 'Передумал ремонтировать / отложил ремонт' },
  { value: '26', label: 'Географически неудобно / далеко ехать' },
  { value: '27', label: 'Ушёл к конкурентам (агрегаторы)' },
  { value: '28', label: 'Записался напрямую' },
];

export const BID_REJECT_COMMENT_MAX_LENGTH = 255;

/** Roles allowed to cancel a bid that is already in work. */
export const CANCEL_IN_WORK_ROLES = ['callcenter-chief', 'callcenter-supervisor', 'sales-director', 'admin'];
